import React, { useState, useEffect } from 'react';
import {
  Mail,
  User,
  MessageSquare,
  Calendar,
  Trash2,
  Search,
  // Filter,
  ChevronLeft,
  ChevronRight,
  Eye,
  Clock,
  Inbox,
  // Archive,
  // Star,
  X,
  Send,
  // Clock as ClockIcon,
  Calendar as CalendarIcon,
  Mail as MailIcon,
  User as UserIcon,
  CheckCircle,
  XIcon
} from 'lucide-react';
import './Contact.css';
import { ApiUrl } from '../API/ApiUrl';
import Swal from 'sweetalert2'

const Contact = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 10;

  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(`${ApiUrl}/contact-messages`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      setMessages(data);

    } catch (error) {
      console.error("Fetch Messages Error:", error);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);
  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This message will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(`${ApiUrl}/contact-messages/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      // Refresh list
      fetchMessages();

      if (selectedMessage?.id === id) {
        setShowModal(false);
        setSelectedMessage(null);
      }

      // Success alert
      Swal.fire({
        title: "Deleted!",
        text: "Message has been deleted successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Delete Error:", error);

      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
      });
    }
  };

  const handleViewMessage = async (message) => {
    const token = localStorage.getItem("adminToken");

    try {
      // Mark as read in DB
      await fetch(`${ApiUrl}/contact-messages/read/${message.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Refresh messages from DB
      fetchMessages();

      setSelectedMessage(message);
      setShowModal(true);

    } catch (error) {
      console.error("Mark Read Error:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const handleReply = () => {
    if (selectedMessage) {
      // In a real app, this would open email client or reply form
      window.location.href = `mailto:${selectedMessage.email}?subject=Re: ${selectedMessage.subject}`;
    }
  };

  // const togglePriority = (id) => {
  //   setMessages(messages.map(item =>
  //     item.id === id
  //       ? { ...item, priority: item.priority === 'high' ? 'medium' : item.priority === 'medium' ? 'low' : 'high' }
  //       : item
  //   ));
  // };

  // Filter messages based on search and status
  const filteredMessages = messages.filter((item) => {

    // Status filter
    let statusMatch = true;

    if (filterStatus === 'unread') {
      statusMatch = item.is_read === 0;
    } else if (filterStatus === 'read') {
      statusMatch = item.is_read === 1;
    }

    // Search filter
    const search = searchTerm.toLowerCase();

    const searchMatch =
      item.name?.toLowerCase().includes(search) ||
      item.email?.toLowerCase().includes(search) ||
      item.subject?.toLowerCase().includes(search) ||
      item.message?.toLowerCase().includes(search);

    return statusMatch && searchMatch;
  });

  // Pagination
  const totalPages = Math.ceil(filteredMessages.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedMessages = filteredMessages.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Get counts
  const unreadCount = messages.filter(m => m.is_read === 0).length;
  // const highPriorityCount = messages.filter(m => m.priority === 'high').length;

  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "", time: "" };

    const dateObj = new Date(dateString);

    const date = dateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = dateObj.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return { date, time };
  };

  const { date, time } = formatDateTime(selectedMessage?.created_at || "");


useEffect(() => {
  setCurrentPage(1);
}, [searchTerm, filterStatus]);

useEffect(() => {
  if (currentPage > totalPages) {
    setCurrentPage(1);
  }
}, [filteredMessages, totalPages]);


  return (
    <div className="contact-page">
      {/* Header */}
      <div className="page-header">
        <div className="title-section">
          <Mail size={40} className="title-icon" />
          <div>
            <h1 className="page-title">Contact Messages</h1>
            <p className="page-subtitle">Manage and respond to user inquiries</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#eff6ff' }}>
            <Inbox size={20} style={{ color: '#3b82f6' }} />
          </div>
          <div className="stat-info">
            <span className="stat-label">Total Messages</span>
            <span className="stat-value">{messages.length}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#fee2e2' }}>
            <Mail size={20}  style={{ color: '#ef4444' }}/>
          </div>
          <div className="stat-info">
            <span className="stat-label">Unread</span>
            <span className="stat-value">{unreadCount}</span>
          </div>
        </div>
        {/* <div className="stat-card">
          <div className="stat-icon">
            <Star size={16} />
          </div>
          <div className="stat-info">
            <span className="stat-label">High Priority</span>
            <span className="stat-value">{highPriorityCount}</span>
          </div>
        </div> */}
        <div className="stat-card">
          <div className="stat-icon"  style={{ background: '#e6f7f0' }}>
            <CheckCircle size={20} style={{ color: '#10b981' }} />
          </div>
          <div className="stat-info">
            <span className="stat-label">Read</span>
            <span className="stat-value">{messages.length - unreadCount}</span>
          </div>
        </div>
      </div>

      {/* Search and Filter Bar */}
      <div className="search-section">
        <div className="search-wrapper">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, subject, or message..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          {searchTerm && (
            <XIcon
              size={16}
              className="clear-icon"
              onClick={() => setSearchTerm("")}
            />
          )}
        </div>

        <div className="filter-tabs">
          <button
            className={`filter-tab ${filterStatus === 'all' ? 'active' : ''}`}
            onClick={() => setFilterStatus('all')}
          >
            All
          </button>
          <button
            className={`filter-tab ${filterStatus === "unread" ? 'active' : ''}`}
            onClick={() => setFilterStatus('unread')}
          >
            Unread
          </button>
          <button
            className={`filter-tab ${filterStatus === "read" ? 'active' : ''}`}
            onClick={() => setFilterStatus('read')}
          >
            Read
          </button>
        </div>
      </div>


      <div className="table-container">
        <div className="table-header">
          <h3>Contact Messages</h3>
          <span className="record-count">{filteredMessages.length} messages</span>
        </div>

        <div className="table-responsive">
          <table className="contact-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Date</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {paginatedMessages.map((item, index) => (
                <tr key={item.id} className={item.is_read === 0 ? 'unread-row' : ''}>
                  <td>
                    <span className="sl-no">{startIndex + index + 1}</span>
                  </td>
                  <td>
                    <div className="name-wrapper">
                      <User size={12} className={`name-icon ${item.priority === 'high' ? 'high-priority' : ''}`} />
                      <span className="contact-name">{item.name}</span>
                      {item.is_read === 0 && (
                        <span className="unread-badge">New</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="email-wrapper">
                      <Mail size={12} className="email-icon" />
                      <span className="email-text">{item.email}</span>
                    </div>
                  </td>
                  <td>
                    <div className="subject-wrapper">
                      <MessageSquare size={12} className="subject-icon" />
                      <span
                        className="subject-text"
                        title={item.subject}
                      >
                        {item.subject.length > 30
                          ? `${item.subject.substring(0, 30)}...`
                          : item.subject}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="message-wrapper">
                      <span className="message-preview" title={item.message}>
                        {item.message.length > 40
                          ? `${item.message.substring(0, 40)}...`
                          : item.message}
                      </span>
                      <button
                        className="view-message-btn"
                        onClick={() => handleViewMessage(item)}
                        title="View full message"
                      >
                        <Eye size={12} />
                      </button>
                    </div>
                  </td>
                  <td>
                    <div className="date-wrapper">
                      {(() => {
                        const { date, time } = formatDateTime(item.created_at);

                        return (
                          <>
                            <Calendar size={12} className="date-icon" />
                            <span className="date-text">{date}</span>

                            <Clock size={12} className="time-icon" />
                            <span className="time-text">{time}</span>
                          </>
                        );
                      })()}
                    </div>
                  </td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                      title="Delete Message"
                    >
                      <Trash2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredMessages.length === 0 && (
            <div className="empty-state">
              <Mail size={40} />
              <p>No messages found</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {filteredMessages.length > 0 && (
          <div className="pagination">
            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <ChevronLeft size={16} />
            </button>

            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>

            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              <ChevronRight size={16} />
            </button>
          </div>
        )}
      </div>

      {/* Message View Modal */}
      {showModal && selectedMessage && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="message-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Message Details</h3>
              <button className="close-btn" onClick={handleCloseModal}>
                <X size={18} />
              </button>
            </div>

            <div className="modal-body">
              <div className="message-detail-row">
                <div className="detail-icon">
                  <UserIcon size={16} />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Name</span>
                  <span className="detail-value">{selectedMessage.name}</span>
                </div>
              </div>

              <div className="message-detail-row">
                <div className="detail-icon">
                  <MailIcon size={16} />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Email</span>
                  <span className="detail-value">{selectedMessage.email}</span>
                </div>
              </div>

              <div className="message-detail-row">
                <div className="detail-icon">
                  <MessageSquare size={16} />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Subject</span>
                  <span className="detail-value subject-value">{selectedMessage.subject}</span>
                </div>
              </div>

              <div className="message-detail-row">
                <div className="detail-icon">
                  <CalendarIcon size={16} />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Date & Time</span>
                  <span className="detail-value">
                    {date} at {time}
                  </span>
                </div>
              </div>

              <div className="message-detail-row message-content-row">
                <div className="detail-icon">
                  <Mail size={16} />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Message</span>
                  <div className="message-content">
                    {selectedMessage.message}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <div className="message-meta">
                {/* <span className={`priority-badge ${selectedMessage.priority}`}>
                  {selectedMessage.priority} priority
                </span> */}
                <span className={`status-badge ${selectedMessage.status}`}>
                  {selectedMessage.status}
                </span>
              </div>
              <div className="modal-actions">
                <button className="btn-secondary" onClick={handleCloseModal}>
                  Close
                </button>
                <button className="btn-primary" onClick={handleReply}>
                  <Send size={14} />
                  <span>Reply</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Quick Stats Footer */}
      {/* <div className="stats-footer">
        <div className="footer-stat">
          <Mail size={14} />
          <span>Total: {messages.length}</span>
        </div>
        <div className="footer-stat">
          <User size={14} />
          <span>Unique Senders: {new Set(messages.map(m => m.email)).size}</span>
        </div>
        <div className="footer-stat">
          <Calendar size={14} />
          <span>Latest: {messages[0]?.date}</span>
        </div>
        <div className="footer-stat">
          <Star size={14} />
          <span>High Priority: {highPriorityCount}</span>
        </div>
      </div> */}
    </div>
  );
};

export default Contact;